import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { InfraLayout } from '../InfraLayout';
import { InfraEntities } from "../InfraEntities";
import { InfraRouterProps } from "../InfraRouterProps";

interface ServerListPageProps extends NSARouterMakerResult, InfraRouterProps { }

export default class ServerListPage extends Component<ServerListPageProps>
{
    override render()
    {
        return (
            <InfraLayout
                {...this.props}
                pages={{
                    entity: InfraEntities.server(this.props),
                    list: {}
                }}
            >
                <></>
            </InfraLayout>
        );
    }
}